import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { PoPrint } from "./PoPrint"
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <PoPrint />
        </>
    )
}